import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { FilterKeys } from '../../../../../shared/projectsV2';
import * as ProjectsV2Store from '../../../../redux/projectsV2';
import { CheckboxFilterGroup, FilterPanel } from '../../../generic/Filter';
import useFetchProjectsAction from '../hooks/useFetchProjectsAction';
import type { ProjectsFilter } from '../../../../../shared/projectsV2';
import type { FilterOption } from '../../../generic/Filter/CheckboxFilterGroup';

const FILTER_OPTIONS: FilterOption[] = [
  { key: 'public', label: 'Public' },
  { key: 'private', label: 'Private' },
];

// map the optional "isPublic" boolean to an array of selected options
const determineSelectedOptions = (filter: ProjectsFilter): string[] => {
  switch (filter.isPublic) {
    case true:
      return ['public'];
    case false:
      return ['private'];
    default:
      return [];
  }
};

const ProjectVisibility: VoidFunctionComponent = () => {
  const filter = useSelector(ProjectsV2Store.selectors.getFilter) as ProjectsFilter;
  const setFilter = useFetchProjectsAction(ProjectsV2Store.actions.setFilter);

  // reduce the two checkboxes down to an optional boolean
  const onSelect = (key: string, selected: boolean) => {
    if (selected) {
      if (key === 'public') {
        setFilter({ ...filter, [FilterKeys.IsPublic]: true });
      } else {
        setFilter({ ...filter, [FilterKeys.IsPublic]: false });
      }
    } else {
      setFilter({ ...filter, [FilterKeys.IsPublic]: undefined });
    }
  };

  return (
    <FilterPanel>
      <CheckboxFilterGroup
        title="Visibility"
        options={FILTER_OPTIONS}
        selectedOptions={determineSelectedOptions(filter)}
        onSelect={onSelect}
      />
    </FilterPanel>
  );
};

export default ProjectVisibility;
